$(document).ready(function () {
  $(document).on('click', '.has-dropdown', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this);
    var $dropdown = $this.next('.dropdown-menu, .grandchild-dropdown');

    var isActive = $dropdown.hasClass('active');


    var $parentWrapper = $this.closest('.dropdown-menu, body');

    $parentWrapper.find('.dropdown-menu, .grandchild-dropdown').not($dropdown).slideUp().removeClass('active');
    $parentWrapper.find('.has-dropdown').not($this).removeClass('active-link');


    if (!isActive) {
      $this.addClass('active-link');
      $dropdown.stop(true, true).slideDown().addClass('active');
    } else {
      $this.removeClass('active-link');
      $dropdown.stop(true, true).slideUp().removeClass('active');
    }
  });


  $(document).on('click', function (e) {
    if (!$(e.target).closest('.has-dropdown, .dropdown-menu, .grandchild-dropdown').length) {
      $('.dropdown-menu, .grandchild-dropdown').slideUp().removeClass('active');
      $('.has-dropdown').removeClass('active-link');
    }
  });
});


$(document).ready(function () {
    function toggleButtonState() {
        var productCards = $('.product-card').length;
        var carouselNextButton = $('.featured-collections-carousel carousel-next-button');
        var screenWidth = $(window).width();

        console.log('Current Screen Width:', screenWidth);
        console.log('Product cards count:', productCards);

        if (screenWidth < 699 && productCards < 2) {
            carouselNextButton.addClass('disabled');
        } else if (screenWidth >= 699 && screenWidth < 999 && productCards < 3) {
            carouselNextButton.addClass('disabled');
        } else {
            console.log('Conditions not met → Remove .disabled');
            carouselNextButton.removeClass('disabled');
        }
    }

    toggleButtonState(); // On load
    $(window).on('resize', toggleButtonState); // On resize
});

